/**
 * Created by Jew on 6/28/2017.
 */
import { Component, Inject } from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from 'app/shared/toast/toast';
import { WaitForImportComponent } from '../google-drive/wait-for-import.component';
import {SocialLogin} from "../../account/social-login";
import {IdexService} from "../../idex.service";

declare const google: string;

@Component({
   selector: 'app-create-dropbox-dialog',
   templateUrl: 'create-dropbox.component.html',
   styleUrls: ['create-dropbox.component.css']
})
export class CreateDropboxComponent {
   private readonly SCOPE = 'https://www.googleapis.com/auth/drive.file';
   title: string;
   isBusiness: boolean;
   public canDrag: boolean;
   error: string;
   path: string;
   access_token_google: string;

   constructor(private dialogRef: MatDialogRef<CreateDropboxComponent>,
      @Inject(MAT_DIALOG_DATA) private data: any,
      private dialog: MatDialog,
      private translate: TranslateService, private toast: Toast,
      private socialLogin: SocialLogin,
      private service: IdexService) {
      this.title = 'Google ' + (this.data.type === 'spreadsheets' ? 'Sheet' : 'Doc');
   }

   connectGoogle(button: MatButton, input: any) {
      if (input.value.length === 0) {
         input.focus();
         return;
      }
      if (/[<|>\\\/:?*"]/g.test(input.value) || /(?=\p{Emoji})(?!\p{Number})/u.test(input.value.replace('#',''))) { // # error when check emoji
         this.translate.get('dropbox.rename_error').subscribe(s => {
            this.error = s;
         });
         return;
      }
      if(input.value.endsWith('.')){
         this.translate.get('dropbox.rename_error_dot').subscribe(s => {
            this.toast.error(s);
         });
         return;
      }
      const next = () => {
         this.createFolder(input.value.trim());
      };

      if (!sessionStorage.getItem('access_token_google')) {
         this.socialLogin.withGoogle().subscribe(result => {
            this.access_token_google = sessionStorage.getItem('access_token_google') as string;
            next();
         });
      } else {
         this.access_token_google = sessionStorage.getItem('access_token_google') as string;
         next();
      }
      this.dialogRef.close(true);
   }

   private async createFolder(filename: string) {
      this.dialogRef.close();
      const dialogRef = this.dialog.open(WaitForImportComponent, { disableClose: true, data: this.data.filesComponent });
      const waiting = dialogRef.componentInstance;
      this.translate.get('googleDoc.create').subscribe(s => { waiting.message = s; });

      const that = this;
      let response = await this.service.getFolderFromGoogleDrive(this.access_token_google, 'zDOX', 'root').toPromise();
      if (response.files.length === 0) {
         let createResponse = await this.service.createFolderInGoogleDrive(this.access_token_google, 'root', 'zDOX').toPromise();
         this.createFile(createResponse.id, filename, waiting);
      } else {
         this.createFile(response.files[0].id, filename, waiting);
      }
   }

   private createFile(folderId: string, fileName: string, waiting: WaitForImportComponent): void {
      let mimeType;
      if (this.data.type === 'spreadsheets') {
         mimeType = 'application/vnd.google-apps.spreadsheet';
      } else {
         mimeType = 'application/vnd.google-apps.document';
      }
      const type = this.data.type;
      this.service.createFileInGoogleDrive(this.access_token_google, folderId, fileName, mimeType).subscribe(res => {
         this.openDocFile(type,res.id);
         waiting.progress = false;
         this.translate.get('dropbox.save').subscribe(s => {
            waiting.message = s;
         });
         this.translate.get('onedrive.saveText').subscribe(s => {
            waiting.saveText = s;
         });
         waiting.status = 'dropbox';
         waiting.path = this.path;
         waiting.id = res.id;
         waiting.name = fileName;
         waiting.isBusiness = this.isBusiness;
         waiting.access_token = this.access_token_google;
         waiting.update();
      }, error => { console.error(error); });

   }

   openDocFile(type, id){
      const url = 'https://docs.google.com/' + type + '/d/' + id + '/edit';
      window.open(url);
   }
}
